/* global wp */
const $ = window.jQuery;
const { __ } = wp.i18n;

export default new class {
  constructor() {
    this.selectors = {
      wrapper: '.js-alert-wrapper',
      button: '.js-alert-button',
    };

    $(document).ready(() => {
      this.init();
    });
  }

  init() {
    this.maybeBindCloseButton();
    if (this.isIE()) {
      this.showMessage();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  isIE() {
    // IE 10 and IE 11
    return /Trident\/|MSIE/.test(window.navigator.userAgent);
  }

  // eslint-disable-next-line class-methods-use-this
  showMessage() {
    const message = __(
      'We see that you are currently using Internet Explorer. For an optimal experience on our website, we recommend Chrome or other modern browser.',
      'yanmar',
    );
    $('body').prepend(
      `<div class="o-wrapper u-margin-top-small js-alert-wrapper">
          <div class="c-alert c-alert--error has-close-button">
            ${message}
            <button class="c-alert__close js-alert-button" type="button" aria-label="${__(
              'Close',
              'yanmar',
            )}">
                &times;
            </button>
          </div>
      </div>`,
    );
  }

  maybeBindCloseButton() {
    $(document).on('click', `${this.selectors.button}`, () => {
      $(this.selectors.wrapper).slideUp();
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/ie-detector.js